import CustomerList from './CustomerList';
import CustomersBranding from './CustomersBranding';
import CustomersHeader from './CustomersHeader';

const getShellWidth = (windowSize) => {
    if (windowSize.width < 576) {
        return '100vw';
    }

    return windowSize.width <= 992 ? '75%' : '50%';
};

const CustomersPage = ({
    appointments,
    goToDashboard,
    goToVerification,
    hospitalImage,
    hospitalLogo,
    hospitalName,
    isLoading,
    windowSize,
}) => {
    const shellWidth = getShellWidth(windowSize);
    const listWidth = windowSize.width < 576 ? '100vw' : '75%';

    return (
        <div className="d-flex flex-column justify-content-start align-items-center" style={{ minHeight: '100vh', width: '100vw', backgroundColor: '#0E94C3' }}>
            <div className="card" style={{ minWidth: shellWidth, minHeight: '100vh', position: 'relative' }}>
                <CustomersHeader goToDashboard={goToDashboard} goToVerification={goToVerification} />
                <CustomersBranding
                    hospitalImage={hospitalImage}
                    hospitalLogo={hospitalLogo}
                    hospitalName={hospitalName}
                    shellWidth={shellWidth}
                />
                <CustomerList appointments={appointments} isLoading={isLoading} listWidth={listWidth} />
            </div>
        </div>
    );
};

export default CustomersPage;
